import VueRouter from 'vue-router';
// import tfaConfirm from './views/tfa-confirm';
import referralPage from './views/referral-page.vue';
import login from './views/login.vue';
import signUp from './views/sign-up.vue';
import passwordReset from './views/password-reset.vue';
import passwordResetInstructions from './views/password-reset-instructions.vue';
import passwordResetConfirm from './views/password-reset-confirm.vue';
import sessionExpired from './views/session-expired.vue';
import offersList from './views/transfers/list.vue';
import offersCreate from './views/transfers/create.vue';
import providerDataViewer from './views/provider-data-viewer.vue';
import transfers from './views/transfers.vue';
import requests from './views/requests.vue';
import recipientList from './views/recipient-list.vue';
import recipientEdit from './views/recipient-edit.vue';
import recipientEditPoster from './views/recipient-edit-poster.vue';
import rateAlertCreate from './views/rate-alert-create.vue';
import userConfirmationLinkResend from './views/user-confirmation-link-resend.vue';
import userConfirmationLinkInstructions from './views/user-confirmation-link-instructions.vue';
import userFormFiller from './views/user-form-filler.vue';
import userMessages from './views/user-messages.vue';
import userProfiles from './views/user-profiles.vue';
import userSettings from './views/user-settings.vue';
import notFound from './views/not-found.vue';
// eslint-disable-next-line import/no-cycle
import store from './store';
import userIdentityVerification from './views/user-identity-verification.vue';
import userAddressVerification from './views/user-address-verification.vue';
import userSelectSendOrReceiveMoney from './views/user-select-send-or-receive-money.vue';
import receivedPayments from './views/received-payments.vue';
import userInvite from './views/user-invite.vue';

// Shopping
import shoppingCategories from './views/shopping/categories.vue';
import shoppingCategory from './views/shopping/category.vue';
import shoppingCheckout from './views/shopping/checkout.vue';

import autoloanHome from './views/autoloans/home.vue';
import autoloanCheckout from './views/autoloans/checkout.vue';

import unregisteredPaymentRequestRoutes from './unregistered-payment-request-routes.js';

import healthCare from './views/health/list.vue';
import healthPackages from './views/health/packages.vue';
import maintenance from './views/maintenance.vue';
import plaidTest from './views/plaid-test.vue';
import helpCenter from './views/help-center.vue';
import ReferralTerms from './views/referral/ReferralTerms.vue';

import unifiedReauthentication from './views/unified-reauthentication.vue'
/**
 * The main set of routes.
 *
 * @todo Consider breaking this into a set of files; or at least separate clauses.
 *
 * @type {VueRouter}
 */
const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/unified/reauth',
            component: unifiedReauthentication,
            name: 'unified-reauth',
            meta: { requiresAuth: false },
        },
        {
            path: '/help-center',
            component: helpCenter,
            meta: { requiresAuth: true },
            name: 'help-center',
        },
        {
            path: '/plaid-test', component: plaidTest, meta: { requiresAuth: true },
        },
        {
            path: '/referral/terms',
            component: ReferralTerms,
            name: 'referral-terms',
            meta: { requiresAuth: false },
        },
        {
            path: '/referral/:referralCode',
            name: 'referral-page',
            component: referralPage,
            props: true,
            beforeEnter: ({ params }, from, next) => {
                if (!params.referralCode) {
                    next({ name: 'offers-list' });
                } else {
                    next();
                }
            },
        },
        { path: '/maintenance', name: 'maintenance', component: maintenance },
        { path: '/login', name: 'login', component: login },
        // { path: '/tfa-confirm', name: 'tfa-confirm', component: tfaConfirm },
        {
            path: '/sign-up/:token?',
            name: 'sign-up',
            component: signUp,
            props: ({ params, query }) => ({
                email: query.email || null,
                token: params.token || null,
            }),
        },
        {
            path: '/sign-up/referral/:referralCode',
            name: 'referral-sign-up',
            component: signUp,
            props: true,
            beforeEnter: ({ params }, from, next) => {
                if (!params.referralCode) {
                    next({ name: 'offers-list' });
                } else {
                    next();
                }
            },
        },
        { path: '/password-reset', name: 'password-reset', component: passwordReset },
        {
            path: '/password-reset-instructions',
            name: 'password-reset-instructions',
            component: passwordResetInstructions,
            meta: { requiresAuth: false },
        },
        {
            path: '/password-reset-confirm/:resetToken?',
            name: 'password-reset-confirm',
            component: passwordResetConfirm,
        },
        {
            path: '/session-expired-or-logged-out',
            name: 'session-expired-or-logged-out',
            component: sessionExpired,
            meta: { requiresAuth: false },
        },
        {
            path: '/',
            meta: {
                requiresAuth: false,
            },
            beforeEnter(to, from, next) {
                const userIsAuthenticated = !!store.state.authToken && store.state.authToken.access_token;
                if (userIsAuthenticated && store.state.user.can_post_offers) {
                    next('/offers/new');
                } else {
                    next('/offers/list');
                }
            },
        },
        {
            path: '/offers/list', name: 'offers-list', component: offersList, meta: { requiresAuth: false },
        },
        {
            path: '/offers/new', name: 'offers-create', component: offersCreate, meta: { requiresAuth: true },
        },
        {
            path: '/offers/:orderId',
            name: 'offer',
            component: offersList,
            meta: {
                requiresAuth: false,
                forceLogin: true,
            },
            props: ({ params }) => ({
                orderId: params.orderId || null,
            }),
        },

        // Transfers
        {
            path: '/transfers', name: 'transfers', component: transfers, meta: { requiresAuth: true },
        },

        // Requests
        {
            path: '/requests',
            name: 'requests',
            component: requests,
            meta: { requiresAuth: true },
        },

        // Recipient list
        {
            path: '/recipient/list', name: 'recipient-list', component: recipientList, meta: { requiresAuth: true },
        },
        {
            path: '/recipient/edit/:id?',
            name: 'recipient-edit',
            component: recipientEdit,
            meta: { requiresAuth: true },
            props: true,
        },
        {
            path: '/recipient/edit-poster/:id?',
            name: 'recipient-edit-poster',
            component: recipientEditPoster,
            meta: { requiresAuth: true },
            props: true,
        },

        {
            path: '/rate-alert/create',
            name: 'rate-alert-create',
            component: rateAlertCreate,
            meta: { requiresAuth: true },
        },

        // User
        {
            path: '/user/form-filler',
            name: 'user-form-filler',
            component: userFormFiller,
            meta: { requiresAuth: true },
        },

        {
            path: '/user/confirmation-link-resend',
            name: 'user-confirmation-link-resend',
            component: userConfirmationLinkResend,
            meta: { requiresAuth: false },
        },

        {
            path: '/user/confirmation-link-instructions',
            name: 'user-confirmation-link-instructions',
            component: userConfirmationLinkInstructions,
            meta: { requiresAuth: false },
        },
        {
            path: '/user/profile/:id?', name: 'user-profiles', component: userProfiles, meta: { requiresAuth: true },
        },
        {
            path: '/user/profile/:id?/post-comment/match/:matchId?',
            name: 'user-profiles-post-comment',
            component: userProfiles,
            meta: { requiresAuth: true },
        },
        {
            path: '/user/settings', name: 'user-settings', component: userSettings, meta: { requiresAuth: true },
        },
        {
            path: '/user/messages',
            name: 'user-messages',
            component: userMessages,
            meta: { requiresAuth: true },
        },
        { path: '*', name: 'not-found', component: notFound },
        {
            path: '/user/identity-verification',
            component: userIdentityVerification,
            meta: { requiresAuth: true },
        },
        {
            path: '/user/address-verification',
            component: userAddressVerification,
            meta: { requiresAuth: true },
        },
        {
            path: '/delivery_methods/delivery_method_providers',
            name: 'provider-data-viewer',
            component: providerDataViewer,
            meta: { requiresAuth: true },
        },
        {
            path: '/user/send-or-receive-money',
            name: 'send-or-receive-money',
            component: userSelectSendOrReceiveMoney,
            meta: { requiresAuth: true },
        },
        {
            path: '/user/received-payments',
            name: 'received-payments',
            component: receivedPayments,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/user/invite',
            name: 'user-invite',
            component: userInvite,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/shopping/categories',
            name: 'shopping-categories',
            component: shoppingCategories,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/shopping/category/:category',
            name: 'shopping-category',
            component: shoppingCategory,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/shopping/checkout',
            name: 'shopping-checkout',
            component: shoppingCheckout,
            meta: {
                requiresAuth: true,
            },
        },

        // Health Insurance
        {
            path: '/healthcare',
            name: 'healthcare',
            component: healthCare,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/healthcare/packages',
            name: 'healthcare-packages',
            component: healthPackages,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/autoloan',
            name: 'autoloans',
            component: autoloanHome,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/autoloan/checkout',
            name: 'autoloans-checkout',
            component: autoloanCheckout,
            meta: {
                requiresAuth: true,
            },
        },
        ...unregisteredPaymentRequestRoutes,
    ],
    scrollBehavior(_to, _from, _savedPosition) {
        return { x: 0, y: 0 };
    },
});

/**
 * Perform validation and setup.
 *
 * @todo Storing user and auth token in local storage is a known security risk; we should consider HTTP-ONLY cookies.
 */
router.beforeEach((to, from, next) => {
    /*
     * If the user info and auth token can be found in local storage, put the user in the Vuex store.
     */
    if (!store.state.user && localStorage.getItem('user') && localStorage.getItem('authToken')) {
        try {
            store.commit('storeUser', JSON.parse(localStorage.getItem('user')));
            store.commit('storeAuthToken', JSON.parse(localStorage.getItem('authToken')));
        } catch (e) {
            // console.trace(e);
            // console.error(e);

            store.commit('storeUser', {});
            store.commit('storeAuthToken', {});
            localStorage.clear();
        }
    }

    /*
     * Handle pages requiring authentication.
     */
    let requiresAuth = false;
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        requiresAuth = true;
    }

    const userIsAuthenticated = !!store.state.authToken && store.state.authToken.access_token;

    if (userIsAuthenticated && to.name === 'login') {
        next({ name: 'offers-list' });
    } else if (!userIsAuthenticated && requiresAuth) {
        next({
            path: '/login',
        });
    } else {
        next();
    }
});

export default router;
